/**
 * 09 §5.8 "Not found": `הדף שחיפשת לא קיים`, with one next step. Never a raw 404, never a blank page.
 */

import { AppShell } from '../shell/AppShell';
import { useLocale } from '../i18n/LocaleProvider';
import { StateBlock } from '../components/StateBlock';
import { routes } from '../routes';

export function NotFoundScreen(): JSX.Element {
  const { t } = useLocale();
  return (
    <AppShell
      /* Every string here goes through `t()`; `translatedScreens.test.ts` fails the build
         if one Hebrew literal survives, which is what makes this a claim and not a note. */
      translated titleHe={t('module.notFoundTitle')}>
      <StateBlock
        titleHe={t('module.notFoundTitle')}
        bodyHe={t('notfound.body')}
        nextStep={
          <a className="btn btn--nav" href={routes.companies}>
            {t('company.backToList')}
          </a>
        }
      />
    </AppShell>
  );
}
